import api from "lib/api";

export const getSmsTemplate = (api_key: string) => {
  return api.get(`/sms/template?api_key=${api_key}`);
};

export const sendSms = (api_key: string, message: string, phone_number: string) => {
  return api.post(`/sms/send`, { api_key, message, phone_number });
};
